// Schema migrations for the DSL/state.
//
// Contract: any DSL string we ship today must continue to load forever. When
// the schema changes (params renamed, layer kinds split, defaults added),
// add a migration step here. Bump STATE_VERSION in types.ts and add an entry
// for the previous version.
//
// v1 is the inaugural version — no migrations yet.

import type { ParsedComposition } from './dsl';
import { STATE_VERSION } from './types';

export type MigrationResult = ParsedComposition | null;

const MIGRATIONS: Record<number, (c: ParsedComposition) => ParsedComposition> = {
  // Example for the future:
  // 1: (c) => ({ ...c, version: 2, layers: c.layers.map(renameSomeParam) }),
};

/**
 * Migrate a parsed composition forward to the current STATE_VERSION.
 * Returns null if the source version is newer than we know about.
 */
export function migrate(c: ParsedComposition): MigrationResult {
  if (c.version === STATE_VERSION) return c;
  if (c.version > STATE_VERSION) return null;

  let cur = c;
  while (cur.version < STATE_VERSION) {
    const step = MIGRATIONS[cur.version];
    if (!step) return null;
    cur = step(cur);
    // Safety: a migration must advance the version.
    if (cur.version <= c.version) return null;
  }
  return cur;
}
